export default __webpack_public_path__ + "static/media/Stewardship.dd4a68fa.png";